import { gql } from "@apollo/client";

export const CREATE_TRAVEL_LANDING_PAGE = gql`
  mutation CreateTravelLandingPage($request: CreateTravelLandingPageRequestInput!) {
    createTravelLandingPage(request: $request) {
      id
      slug
      name
      status
      pageType
      defaultLocale
    }
  }
`;

export const UPDATE_TRAVEL_LANDING_PAGE = gql`
  mutation UpdateTravelLandingPage($id: UUID!, $request: UpdateTravelLandingPageRequestInput!) {
    updateTravelLandingPage(id: $id, request: $request) {
      id
      slug
      name
      status
      defaultLocale
      updatedAt
    }
  }
`;

export const PUBLISH_TRAVEL_LANDING_PAGE = gql`
  mutation PublishTravelLandingPage($id: UUID!) {
    publishTravelLandingPage(id: $id) {
      id
      status
      publishedAt
    }
  }
`;

export const UNPUBLISH_TRAVEL_LANDING_PAGE = gql`
  mutation UnpublishTravelLandingPage($id: UUID!) {
    unpublishTravelLandingPage(id: $id) {
      id
      status
    }
  }
`;

export const ARCHIVE_TRAVEL_LANDING_PAGE = gql`
  mutation ArchiveTravelLandingPage($id: UUID!) {
    archiveTravelLandingPage(id: $id) {
      id
      status
    }
  }
`;

export const UPLOAD_TRAVEL_LANDING_PAGE_IMAGE = gql`
  mutation UploadTravelLandingPageImage($file: Upload!) {
    uploadTravelLandingPageImage(file: $file) {
      url
    }
  }
`;
